import { useCallback, useEffect, useRef, useState } from 'react';
import { DataProviderInstance } from '../../../api/DataProvider';

/** Períodos do card: deslocamento do início e quantos dias depois termina */
export const PERIODS = [
  { id: 'today', label: 'Hoje', offset: 0, days: 0 },
  { id: 'tomorrow', label: 'Amanhã', offset: 1, days: 0 },
  { id: 'week', label: '7 dias', offset: 0, days: 7 },
];

function toYMD(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

function periodRange(periodId) {
  const period = PERIODS.find((p) => p.id === periodId) || PERIODS[2];
  const start = new Date();
  start.setDate(start.getDate() + period.offset);
  const end = new Date(start);
  end.setDate(end.getDate() + period.days);
  return { startDate: toYMD(start), endDate: toYMD(end) };
}

/**
 * Atendimentos por convênio com pendência crítica no período (regra no backend:
 * InsurancePendencies.php). `enabled` falso = nenhuma busca (empresa sem operadora).
 */
export default function useInsurancePending(enabled) {
  const { GetInsurancePending } = DataProviderInstance();
  const [period, setPeriod] = useState('week');
  const [state, setState] = useState({ status: 'loading', items: [], error: null });
  const request = useRef(0);

  const load = useCallback(() => {
    if (!enabled) return;
    const current = ++request.current;
    setState((prev) => ({ ...prev, status: 'loading', error: null }));
    GetInsurancePending(periodRange(period), (result) => {
      if (current !== request.current) return;
      const data = result?.status === 'SUCCESS' ? result.data : null;
      if (!data) {
        setState({ status: 'error', items: [], error: result?.error || 'Não foi possível conferir agora.' });
        return;
      }
      setState({ status: 'ready', items: Array.isArray(data.items) ? data.items : [], error: null });
    });
  }, [GetInsurancePending, enabled, period]);

  useEffect(() => { load(); }, [load]);

  return { period, setPeriod, ...state, reload: load };
}
